module.exports = __webpack_public_path__ + "static/img/02.b38e6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/02.png
// module id = fX+t
// module chunks = 1